import { basePath } from "./config";
import axios from "axios";
import { getAccessTokenApi, getTokenCiudadano } from "./auth";

export function save(organitation) {
  const url = `${basePath}/organizacion`;
  const jwt = getAccessTokenApi();
  return axios.post(url, organitation, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: jwt,
    },
  });
}

export function saveOrg(organitation) {
  const url = `${basePath}/organizaciones`;
  const jwt = getAccessTokenApi();
  return axios.post(url, organitation, {
    headers: {Authorization: jwt },
  });
}

export function saveOrgPP(organitation) {
  const url = `${basePath}/organizacion/guardarPP`;
  const jwt = getTokenCiudadano();
  return axios.post(url, organitation, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: jwt,
    },
  });
}

export function update(organitation) {
  const url = `${basePath}/organizacion/actualizar`;
  const jwt = getAccessTokenApi();
  return axios.post(url, organitation, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: jwt,
    },
  });
}


export function updatePP(organitation) {
  const url = `${basePath}/organizacion/actualizar`;
  const jwt = getTokenCiudadano();
  return axios.post(url, organitation, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: jwt,
    },
  });
}

export function updateOrg(organitation) {
  const url = `${basePath}/organizaciones/actualizar`;
  const jwt = getAccessTokenApi();
  return axios.post(url, organitation, {
    headers: {Authorization: jwt},
  });
}

export function updateOrgPP(organitation) {
  const url = `${basePath}/organizaciones/actualizar`;
  const jwt = getTokenCiudadano();
  return axios.post(url, organitation, {
    headers: {Authorization: jwt},
  });
}

export function getOrganitation(status, idProceso, idDetalle) {
  const url = `${basePath}/organizacion/tabla`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { estatus: status, idProceso: idProceso, idDetalle: idDetalle },
    {
      headers: { Authorization: jwt, Parametrizacion: idProceso },
    }
  );
}

export function getOrganitationViewUpd(status, idProceso, idDetalle, idOrganizacion) {
  const url = `${basePath}/organizacion/vistaAct`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { estatus: status, idProceso: idProceso, idDetalle: idDetalle, idOrganizacion: idOrganizacion},
    {
      headers: { Authorization: jwt},
    }
  );
}

export function getOrganitationViewUpdPP(status, idProceso, idDetalle, idOrganizacion) {
  const url = `${basePath}/organizacion/vistaAct`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { estatus: status, idProceso: idProceso, idDetalle: idDetalle, idOrganizacion: idOrganizacion},
    {
      headers: { Authorization: jwt},
    }
  );
}

export function getTypeOrganitation() {
  const url = `${basePath}/organizacion/tipos`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    {},
    {
      headers: { Authorization: jwt },
    }
  );
}

export function getTypeOrganitationPP() {
  const url = `${basePath}/organizacion/tipos`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    {},
    {
      headers: { Authorization: jwt },
    }
  );
}

export function deleted(id, correosVocalesStr) {
  const url = `${basePath}/organizacion/estatus`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { idOrganizacion: id, correosVocalesStr: correosVocalesStr },
    {
      headers: { Authorization: jwt },
    }
  );
}

export function getEntidad() {
  const url = `${basePath}/geografico`;
  const jwt = getAccessTokenApi();
  return axios.post(url, {}, { headers: { Authorization: jwt } });
}

export function getEntidadPP() {
  const url = `${basePath}/geografico`;
  const jwt = getTokenCiudadano();
  return axios.post(url, {}, { headers: { Authorization: jwt } });
}

export function getMunicipios(idEstado) {
  const url = `${basePath}/municipio`;
  const jwt = getAccessTokenApi();
  return axios.post(url, { idEstado: idEstado }, { headers: { Authorization: jwt } });
}

export function getMunicipiosPP(idEstado) {
  const url = `${basePath}/municipio`;
  const jwt = getTokenCiudadano();
  return axios.post(url, { idEstado: idEstado }, { headers: { Authorization: jwt } });
}

export function getDownload(json) {
  const url = `${basePath}/organizacion/descarga`;
  const jwt = getAccessTokenApi();
  return axios.post(url, json, {
    headers: {
      "Content-Type": "application/json",
      Authorization: jwt,
    },
    responseType: "blob",
  });
}

export function getDownloadPP(json) {
  const url = `${basePath}/organizacion/descarga`;
  const jwt = getTokenCiudadano();
  return axios.post(url, json, {
    headers: {
      "Content-Type": "application/json",
      Authorization: jwt,
    },
    responseType: "blob",
  });
}

export function getDatosHomeOrg(correo) {
  const url = `${basePath}/organizacion/homeOrg`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { correo: correo },
    {
      headers: { Authorization: jwt, Origen: "portal" },
    }
  );
}

export function getOrganizacionConObs(estatus, idProceso, idDetalle, idOrg) {
  const url = `${basePath}/correcObsOrg/organizacionObs`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { estatus: estatus, idProceso: idProceso, idDetalle: idDetalle, idOrganizacion: idOrg },
    {
      headers: { Authorization: jwt, Origen: "portal" },
    }
  );
}

export function updateObsOrg(organitation) {
  const url = `${basePath}/correcObsOrg/actualizaOrg`;
  const jwt = getTokenCiudadano();
  return axios.post(url, organitation, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: jwt,
    },
  });
}